export default {
  // =========================================================================
  // SECTOR Windfall — GRID (parent group, references sub-variables below)
  // =========================================================================
  windfall: {
    type: "likert_grid",
    label: "Windfall tax",
    netLabel: "support for a windfall tax",
    fulltext: "How comfortable or uncomfortable would you be with the following sectors being asked to pay more through extra taxes or one-off levies?",
    sidebarCompareSubtitle: "Compare attitudes to windfall taxes across all sectors, or drill into one.",
    sidebarCompareButton: "Compare all sectors",
    sidebarDrillTitle: "Drill into a sector",
    sidebarDrillSubtitle: "Select a sector for individual results.",
    sidebarDrillSubtitleTarget: "Select one sector for targeting.",
    client: "stack-data-strategy",
    category: "business",
    subVariables: [
      "windfall_oil",
      "windfall_big",
      "windfall_banks",
      "windfall_online",
      "windfall_propertydev",
      "windfall_supermarkets",
      "windfall_hospitality",
      "windfall_construction",
      "windfall_defence",
      "windfall_gambling",
      "windfall_energy",
      "windfall_water",
      "windfall_healthcare",
      "windfall_farming",
    ],
    subLabels: {
      "windfall_oil":           "Oil & gas",
      "windfall_big":           "Big tech",
      "windfall_banks":         "Banks & financial services",
      "windfall_online":        "Online retailers",
      "windfall_propertydev":   "Property developers",
      "windfall_supermarkets":  "Supermarkets & large retailers",
      "windfall_hospitality":   "Hospitality",
      "windfall_construction":  "Construction & infrastructure",
      "windfall_defence":       "Defence contractors",
      "windfall_gambling":      "Gambling",
      "windfall_energy":        "Energy companies",
      "windfall_water":         "Water & utilities",
      "windfall_healthcare":    "Healthcare & pharma",
      "windfall_farming":       "Farming & food production",
    },
    subColors: {
      "windfall_oil":           "#5D4037",
      "windfall_big":           "#7B1FA2",
      "windfall_banks":         "#1565C0",
      "windfall_online":        "#388E3C",
      "windfall_propertydev":   "#8D6E63",
      "windfall_supermarkets":  "#43A047",
      "windfall_hospitality":   "#FB8C00",
      "windfall_construction":  "#F9A825",
      "windfall_defence":       "#6D4C41",
      "windfall_gambling":      "#C62828",
      "windfall_energy":        "#F57C00",
      "windfall_water":         "#0097A7",
      "windfall_healthcare":    "#D81B60",
      "windfall_farming":       "#33691E",
    },
    keys: [
      "pol:windfall:oil:windfall_comfortable:lik", "pol:windfall:oil:windfall_neutral:lik", "pol:windfall:oil:windfall_uncomfortable:lik", "pol:windfall:oil:windfall_dk:lik",
      "pol:windfall:big:windfall_comfortable:lik", "pol:windfall:big:windfall_neutral:lik", "pol:windfall:big:windfall_uncomfortable:lik", "pol:windfall:big:windfall_dk:lik",
      "pol:windfall:banks:comfortable:lik", "pol:windfall:banks:neutral:lik", "pol:windfall:banks:uncomfortable:lik", "pol:windfall:banks:dk:lik",
      "pol:windfall:online:comfortable:lik", "pol:windfall:online:neutral:lik", "pol:windfall:online:uncomfortable:lik", "pol:windfall:online:dk:lik",
      "pol:windfall:propertydev:comfortable:lik", "pol:windfall:propertydev:neutral:lik", "pol:windfall:propertydev:uncomfortable:lik", "pol:windfall:propertydev:dk:lik",
      "pol:windfall:supermarkets:comfortable:lik", "pol:windfall:supermarkets:neutral:lik", "pol:windfall:supermarkets:uncomfortable:lik", "pol:windfall:supermarkets:dk:lik",
      "pol:windfall:hospitality:comfortable:lik", "pol:windfall:hospitality:neutral:lik", "pol:windfall:hospitality:uncomfortable:lik", "pol:windfall:hospitality:dk:lik",
      "pol:windfall:construction:comfortable:lik", "pol:windfall:construction:neutral:lik", "pol:windfall:construction:uncomfortable:lik", "pol:windfall:construction:dk:lik",
      "pol:windfall:defence:comfortable:lik", "pol:windfall:defence:neutral:lik", "pol:windfall:defence:uncomfortable:lik", "pol:windfall:defence:dk:lik",
      "pol:windfall:gambling:comfortable:lik", "pol:windfall:gambling:neutral:lik", "pol:windfall:gambling:uncomfortable:lik", "pol:windfall:gambling:dk:lik",
      "pol:windfall:energy:comfortable:lik", "pol:windfall:energy:neutral:lik", "pol:windfall:energy:uncomfortable:lik", "pol:windfall:energy:dk:lik",
      "pol:windfall:water:comfortable:lik", "pol:windfall:water:neutral:lik", "pol:windfall:water:uncomfortable:lik", "pol:windfall:water:dk:lik",
      "pol:windfall:healthcare:comfortable:lik", "pol:windfall:healthcare:neutral:lik", "pol:windfall:healthcare:uncomfortable:lik", "pol:windfall:healthcare:dk:lik",
      "pol:windfall:farming:comfortable:lik", "pol:windfall:farming:neutral:lik", "pol:windfall:farming:uncomfortable:lik", "pol:windfall:farming:dk:lik",
    ],
    labels: {},
    schema: "tracking",
    waves: [2,3,4]
  },

  // =========================================================================
  // WINDFALL TAX (likert — one group per sector)
  // =========================================================================

  windfall_oil: {
    type: "likert",
    label: "Windfall tax: Oil & gas",
    fulltext: "How comfortable or uncomfortable would you be with the following sectors being asked to pay more through extra taxes or one-off levies? Oil and gas companies",
    client: "stack-data-strategy",
    hidden: true,
    keys: [
      "pol:windfall:oil:windfall_comfortable:lik",
      "pol:windfall:oil:windfall_neutral:lik",
      "pol:windfall:oil:windfall_uncomfortable:lik",
      "pol:windfall:oil:windfall_dk:lik"
    ],
    labels: {
      "pol:windfall:oil:windfall_comfortable:lik":   "Comfortable",
      "pol:windfall:oil:windfall_neutral:lik":       "Neutral",
      "pol:windfall:oil:windfall_uncomfortable:lik": "Uncomfortable",
      "pol:windfall:oil:windfall_dk:lik":            "Don't know"
    },
    polarity: {
      pos: "pol:windfall:oil:windfall_comfortable:lik",
      neu: "pol:windfall:oil:windfall_neutral:lik",
      neg: "pol:windfall:oil:windfall_uncomfortable:lik",
      dk:  "pol:windfall:oil:windfall_dk:lik"
    },
    schema: "tracking",
    waves: [2,3,4]
  },

  windfall_big: {
    type: "likert",
    label: "Windfall tax: Big tech",
    fulltext: "How comfortable or uncomfortable would you be with the following sectors being asked to pay more through extra taxes or one-off levies? Big tech companies",
    client: "stack-data-strategy",
    hidden: true,
    keys: [
      "pol:windfall:big:windfall_comfortable:lik",
      "pol:windfall:big:windfall_neutral:lik",
      "pol:windfall:big:windfall_uncomfortable:lik",
      "pol:windfall:big:windfall_dk:lik"
    ],
    labels: {
      "pol:windfall:big:windfall_comfortable:lik":   "Comfortable",
      "pol:windfall:big:windfall_neutral:lik":       "Neutral",
      "pol:windfall:big:windfall_uncomfortable:lik": "Uncomfortable",
      "pol:windfall:big:windfall_dk:lik":            "Don't know"
    },
    polarity: {
      pos: "pol:windfall:big:windfall_comfortable:lik",
      neu: "pol:windfall:big:windfall_neutral:lik",
      neg: "pol:windfall:big:windfall_uncomfortable:lik",
      dk:  "pol:windfall:big:windfall_dk:lik"
    },
    schema: "tracking",
    waves: [2,3,4]
  },

  windfall_banks: {
    type: "likert",
    label: "Windfall tax: Banks & financial services",
    fulltext: "How comfortable or uncomfortable would you be with the following sectors being asked to pay more through extra taxes or one-off levies? Banks and financial services",
    client: "stack-data-strategy",
    hidden: true,
    keys: [
      "pol:windfall:banks:comfortable:lik",
      "pol:windfall:banks:neutral:lik",
      "pol:windfall:banks:uncomfortable:lik",
      "pol:windfall:banks:dk:lik",
    ],
    labels: {
      "pol:windfall:banks:comfortable:lik":   "Comfortable",
      "pol:windfall:banks:neutral:lik":       "Neutral",
      "pol:windfall:banks:uncomfortable:lik": "Uncomfortable",
      "pol:windfall:banks:dk:lik":            "Don't know"
    },
    polarity: {
      pos: "pol:windfall:banks:comfortable:lik",
      neu: "pol:windfall:banks:neutral:lik",
      neg: "pol:windfall:banks:uncomfortable:lik",
      dk:  "pol:windfall:banks:dk:lik",
    },
    schema: "tracking",
    waves: [2,3,4]
  },

  windfall_online: {
    type: "likert",
    label: "Windfall tax: Online retailers",
    fulltext: "How comfortable or uncomfortable would you be with the following sectors being asked to pay more through extra taxes or one-off levies? Online retailers",
    client: "stack-data-strategy",
    hidden: true,
    keys: [
      "pol:windfall:online:comfortable:lik",
      "pol:windfall:online:neutral:lik",
      "pol:windfall:online:uncomfortable:lik",
      "pol:windfall:online:dk:lik"
    ],
    labels: {
      "pol:windfall:online:comfortable:lik":   "Comfortable",
      "pol:windfall:online:neutral:lik":       "Neutral",
      "pol:windfall:online:uncomfortable:lik": "Uncomfortable",
      "pol:windfall:online:dk:lik":            "Don't know"
    },
    polarity: {
      pos: "pol:windfall:online:comfortable:lik",
      neu: "pol:windfall:online:neutral:lik",
      neg: "pol:windfall:online:uncomfortable:lik",
      dk:  "pol:windfall:online:dk:lik"
    },
    schema: "tracking",
    waves: [2,3,4]
  },

  windfall_propertydev: {
    type: "likert",
    label: "Windfall tax: Property developers",
    fulltext: "How comfortable or uncomfortable would you be with the following sectors being asked to pay more through extra taxes or one-off levies? Property developers",
    client: "stack-data-strategy",
    hidden: true,
    keys: [
      "pol:windfall:propertydev:comfortable:lik",
      "pol:windfall:propertydev:neutral:lik",
      "pol:windfall:propertydev:uncomfortable:lik",
      "pol:windfall:propertydev:dk:lik"
    ],
    labels: {
      "pol:windfall:propertydev:comfortable:lik":   "Comfortable",
      "pol:windfall:propertydev:neutral:lik":       "Neutral",
      "pol:windfall:propertydev:uncomfortable:lik": "Uncomfortable",
      "pol:windfall:propertydev:dk:lik":            "Don't know"
    },
    polarity: {
      pos: "pol:windfall:propertydev:comfortable:lik",
      neu: "pol:windfall:propertydev:neutral:lik",
      neg: "pol:windfall:propertydev:uncomfortable:lik",
      dk:  "pol:windfall:propertydev:dk:lik"
    },
    schema: "tracking",
    waves: [2,3,4]
  },

  windfall_supermarkets: {
    type: "likert",
    label: "Windfall tax: Supermarkets & large retailers",
    fulltext: "How comfortable or uncomfortable would you be with the following sectors being asked to pay more through extra taxes or one-off levies? Supermarkets and large retailers",
    client: "stack-data-strategy",
    hidden: true,
    keys: [
      "pol:windfall:supermarkets:comfortable:lik",
      "pol:windfall:supermarkets:neutral:lik",
      "pol:windfall:supermarkets:uncomfortable:lik",
      "pol:windfall:supermarkets:dk:lik"
    ],
    labels: {
      "pol:windfall:supermarkets:comfortable:lik":   "Comfortable",
      "pol:windfall:supermarkets:neutral:lik":       "Neutral",
      "pol:windfall:supermarkets:uncomfortable:lik": "Uncomfortable",
      "pol:windfall:supermarkets:dk:lik":            "Don't know"
    },
    polarity: {
      pos: "pol:windfall:supermarkets:comfortable:lik",
      neu: "pol:windfall:supermarkets:neutral:lik",
      neg: "pol:windfall:supermarkets:uncomfortable:lik",
      dk:  "pol:windfall:supermarkets:dk:lik"
    },
    schema: "tracking",
    waves: [2,3,4]
  },

  windfall_hospitality: {
    type: "likert",
    label: "Windfall tax: Hospitality",
    fulltext: "How comfortable or uncomfortable would you be with the following sectors being asked to pay more through extra taxes or one-off levies? Hospitality (e.g. restaurants, hotels)",
    client: "stack-data-strategy",
    hidden: true,
    keys: [
      "pol:windfall:hospitality:comfortable:lik",
      "pol:windfall:hospitality:neutral:lik",
      "pol:windfall:hospitality:uncomfortable:lik",
      "pol:windfall:hospitality:dk:lik"
    ],
    labels: {
      "pol:windfall:hospitality:comfortable:lik":   "Comfortable",
      "pol:windfall:hospitality:neutral:lik":       "Neutral",
      "pol:windfall:hospitality:uncomfortable:lik": "Uncomfortable",
      "pol:windfall:hospitality:dk:lik":            "Don't know"
    },
    polarity: {
      pos: "pol:windfall:hospitality:comfortable:lik",
      neu: "pol:windfall:hospitality:neutral:lik",
      neg: "pol:windfall:hospitality:uncomfortable:lik",
      dk:  "pol:windfall:hospitality:dk:lik"
    },
    schema: "tracking",
    waves: [2,3,4]
  },

  windfall_construction: {
    type: "likert",
    label: "Windfall tax: Construction & infrastructure",
    fulltext: "How comfortable or uncomfortable would you be with the following sectors being asked to pay more through extra taxes or one-off levies? Construction and infrastructure companies",
    client: "stack-data-strategy",
    hidden: true,
    keys: [
      "pol:windfall:construction:comfortable:lik",
      "pol:windfall:construction:neutral:lik",
      "pol:windfall:construction:uncomfortable:lik",
      "pol:windfall:construction:dk:lik"
    ],
    labels: {
      "pol:windfall:construction:comfortable:lik":   "Comfortable",
      "pol:windfall:construction:neutral:lik":       "Neutral",
      "pol:windfall:construction:uncomfortable:lik": "Uncomfortable",
      "pol:windfall:construction:dk:lik":            "Don't know"
    },
    polarity: {
      pos: "pol:windfall:construction:comfortable:lik",
      neu: "pol:windfall:construction:neutral:lik",
      neg: "pol:windfall:construction:uncomfortable:lik",
      dk:  "pol:windfall:construction:dk:lik"
    },
    schema: "tracking",
    waves: [2,3,4]
  },

  windfall_defence: {
    type: "likert",
    label: "Windfall tax: Defence contractors",
    fulltext: "How comfortable or uncomfortable would you be with the following sectors being asked to pay more through extra taxes or one-off levies? Defence contractors",
    client: "stack-data-strategy",
    hidden: true,
    keys: [
      "pol:windfall:defence:comfortable:lik",
      "pol:windfall:defence:neutral:lik",
      "pol:windfall:defence:uncomfortable:lik",
      "pol:windfall:defence:dk:lik"
    ],
    labels: {
      "pol:windfall:defence:comfortable:lik":   "Comfortable",
      "pol:windfall:defence:neutral:lik":       "Neutral",
      "pol:windfall:defence:uncomfortable:lik": "Uncomfortable",
      "pol:windfall:defence:dk:lik":            "Don't know"
    },
    polarity: {
      pos: "pol:windfall:defence:comfortable:lik",
      neu: "pol:windfall:defence:neutral:lik",
      neg: "pol:windfall:defence:uncomfortable:lik",
      dk:  "pol:windfall:defence:dk:lik"
    },
    schema: "tracking",
    waves: [2,3,4]
  },

  windfall_manufacturing: {
    type: "likert",
    label: "Windfall tax: Manufacturing",
    fulltext: "How comfortable or uncomfortable would you be with the following sectors being asked to pay more through extra taxes or one-off levies? Manufacturing firms",
    client: "stack-data-strategy",
    hidden: true,
    keys: [
      "pol:windfall:manufacturing:comfortable:lik",
      "pol:windfall:manufacturing:neutral:lik",
      "pol:windfall:manufacturing:uncomfortable:lik",
      "pol:windfall:manufacturing:dk:lik"
    ],
    labels: {
      "pol:windfall:manufacturing:comfortable:lik":   "Comfortable",
      "pol:windfall:manufacturing:neutral:lik":       "Neutral",
      "pol:windfall:manufacturing:uncomfortable:lik": "Uncomfortable",
      "pol:windfall:manufacturing:dk:lik":            "Don't know"
    },
    polarity: {
      pos: "pol:windfall:manufacturing:comfortable:lik",
      neu: "pol:windfall:manufacturing:neutral:lik",
      neg: "pol:windfall:manufacturing:uncomfortable:lik",
      dk:  "pol:windfall:manufacturing:dk:lik"
    },
    schema: "tracking",
    waves: [2,3]
  },

  windfall_gambling: {
    type: "likert",
    label: "Windfall tax: Gambling",
    fulltext: "How comfortable or uncomfortable would you be with the following sectors being asked to pay more through extra taxes or one-off levies? Gambling companies",
    client: "stack-data-strategy",
    hidden: true,
    keys: [
      "pol:windfall:gambling:comfortable:lik",
      "pol:windfall:gambling:neutral:lik",
      "pol:windfall:gambling:uncomfortable:lik",
      "pol:windfall:gambling:dk:lik"
    ],
    labels: {
      "pol:windfall:gambling:comfortable:lik":   "Comfortable",
      "pol:windfall:gambling:neutral:lik":       "Neutral",
      "pol:windfall:gambling:uncomfortable:lik": "Uncomfortable",
      "pol:windfall:gambling:dk:lik":            "Don't know"
    },
    polarity: {
      pos: "pol:windfall:gambling:comfortable:lik",
      neu: "pol:windfall:gambling:neutral:lik",
      neg: "pol:windfall:gambling:uncomfortable:lik",
      dk:  "pol:windfall:gambling:dk:lik"
    },
    schema: "tracking",
    waves: [2,3,4]
  },

  windfall_energy: {
    type: "likert",
    label: "Windfall tax: Energy companies",
    fulltext: "How comfortable or uncomfortable would you be with the following sectors being asked to pay more through extra taxes or one-off levies? Energy companies",
    client: "stack-data-strategy",
    hidden: true,
    keys: [
      "pol:windfall:energy:comfortable:lik",
      "pol:windfall:energy:neutral:lik",
      "pol:windfall:energy:uncomfortable:lik",
      "pol:windfall:energy:dk:lik"
    ],
    labels: {
      "pol:windfall:energy:comfortable:lik":   "Comfortable",
      "pol:windfall:energy:neutral:lik":       "Neutral",
      "pol:windfall:energy:uncomfortable:lik": "Uncomfortable",
      "pol:windfall:energy:dk:lik":            "Don't know"
    },
    polarity: {
      pos: "pol:windfall:energy:comfortable:lik",
      neu: "pol:windfall:energy:neutral:lik",
      neg: "pol:windfall:energy:uncomfortable:lik",
      dk:  "pol:windfall:energy:dk:lik"
    },
    schema: "tracking",
    waves: [4]
  },

  windfall_water: {
    type: "likert",
    label: "Windfall tax: Water & utilities",
    fulltext: "How comfortable or uncomfortable would you be with the following sectors being asked to pay more through extra taxes or one-off levies? Water and utility companies",
    client: "stack-data-strategy",
    hidden: true,
    keys: [
      "pol:windfall:water:comfortable:lik",
      "pol:windfall:water:neutral:lik",
      "pol:windfall:water:uncomfortable:lik",
      "pol:windfall:water:dk:lik"
    ],
    labels: {
      "pol:windfall:water:comfortable:lik":   "Comfortable",
      "pol:windfall:water:neutral:lik":       "Neutral",
      "pol:windfall:water:uncomfortable:lik": "Uncomfortable",
      "pol:windfall:water:dk:lik":            "Don't know"
    },
    polarity: {
      pos: "pol:windfall:water:comfortable:lik",
      neu: "pol:windfall:water:neutral:lik",
      neg: "pol:windfall:water:uncomfortable:lik",
      dk:  "pol:windfall:water:dk:lik"
    },
    schema: "tracking",
    waves: [4]
  },

  windfall_healthcare: {
    type: "likert",
    label: "Windfall tax: Healthcare & pharma",
    fulltext: "How comfortable or uncomfortable would you be with the following sectors being asked to pay more through extra taxes or one-off levies? Healthcare, life sciences and pharmaceutical companies",
    client: "stack-data-strategy",
    hidden: true,
    keys: [
      "pol:windfall:healthcare:comfortable:lik",
      "pol:windfall:healthcare:neutral:lik",
      "pol:windfall:healthcare:uncomfortable:lik",
      "pol:windfall:healthcare:dk:lik"
    ],
    labels: {
      "pol:windfall:healthcare:comfortable:lik":   "Comfortable",
      "pol:windfall:healthcare:neutral:lik":       "Neutral",
      "pol:windfall:healthcare:uncomfortable:lik": "Uncomfortable",
      "pol:windfall:healthcare:dk:lik":            "Don't know"
    },
    polarity: {
      pos: "pol:windfall:healthcare:comfortable:lik",
      neu: "pol:windfall:healthcare:neutral:lik",
      neg: "pol:windfall:healthcare:uncomfortable:lik",
      dk:  "pol:windfall:healthcare:dk:lik"
    },
    schema: "tracking",
    waves: [4]
  },

  windfall_farming: {
    type: "likert",
    label: "Windfall tax: Farming & food production",
    fulltext: "How comfortable or uncomfortable would you be with the following sectors being asked to pay more through extra taxes or one-off levies? Farming and food production companies",
    client: "stack-data-strategy",
    hidden: true,
    keys: [
      "pol:windfall:farming:comfortable:lik",
      "pol:windfall:farming:neutral:lik",
      "pol:windfall:farming:uncomfortable:lik",
      "pol:windfall:farming:dk:lik"
    ],
    labels: {
      "pol:windfall:farming:comfortable:lik":   "Comfortable",
      "pol:windfall:farming:neutral:lik":       "Neutral",
      "pol:windfall:farming:uncomfortable:lik": "Uncomfortable",
      "pol:windfall:farming:dk:lik":            "Don't know"
    },
    polarity: {
      pos: "pol:windfall:farming:comfortable:lik",
      neu: "pol:windfall:farming:neutral:lik",
      neg: "pol:windfall:farming:uncomfortable:lik",
      dk:  "pol:windfall:farming:dk:lik"
    },
    schema: "tracking",
    waves: [4]
  },
};
